import { html } from 'lit-element';
import { TmnConfirmationToolBase } from '@trumedianetworks/tmn-core-components/src/tmn-tool-base';
import '@trumedianetworks/tmn-core-components/src/tmn-tooltip';

class ResetPackageBtn extends TmnConfirmationToolBase {
    constructor() {
        super();
        this.disabled = false;
        this.buttonColor = 'error';
        this.controlType = 'icon-button';
    }

    static get properties() {
        return {
            disabled: {
                type: Boolean,
            },
            name: {
                type: String,
            },
            eventData: {
                type: Object,
            },
        };
    }

    getButtonLabel() {
        return 'Retry Package';
    }

    getToolTitle() {
        return 'Retry Package';
    }

    getConfirmationLabel() {
        const { name } = this;
        return `Are you sure want to retry pacakge for ${name}?`;
    }

    renderIconButton() {
        return html`<tmn-icon-button
            @click=${this._toggleDialog}
            .eventData=${this.eventData}
            variant="text">
            <tmn-icon iconvariant="outlined" icon="lock_reset"></tmn-icon
        ></tmn-icon-button>`;
    }

    _handleConfirm(e) {
        // could pass in actions as an alternative
        const { eventData } = this;
        this._toggleDialog();
        const event = new CustomEvent('tmn-retry-package-confirmed', {
            detail: {
                ...eventData,
            },
        });
        this.dispatchEvent(event);
    }
}

window.customElements.define('retry-package-btn', ResetPackageBtn);
